
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
import PopupShell from './PopupShell.vue';
import header from '../assets/popup-header-winning.png';
import { PrizeRecord, isPhysicalPrize } from '../data';

Vue.use(List);

/** 我的中奖记录弹窗（滚动到底部加载下一页） */
@Component({
  components: { PopupShell },
})
export default class MyPrizePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Array, default: () => [] }) readonly list!: PrizeRecord[];
  // 是否正在加载下一页
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean;
  // 是否已加载完所有数据
  @Prop({ type: Boolean, default: false }) readonly finished!: boolean;

  header = header;

  get hasList(): boolean {
    return !!this.list && this.list.length > 0;
  }

  // 是否实物奖品（workType=3）
  isPhysical(workType?: number): boolean {
    return isPhysicalPrize(workType);
  }

  // 配合 van-list 的 v-model，把加载状态同步给父组件
  get listLoading(): boolean {
    return this.loading;
  }

  set listLoading(val: boolean) {
    this.$emit('update:loading', val);
  }
}
